import { render, staticRenderFns } from "./TeacherattendaceList.vue?vue&type=template&id=40016b82&scoped=true&"
import script from "./TeacherattendaceList.vue?vue&type=script&lang=js&"
export * from "./TeacherattendaceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40016b82",
  null
  
)

export default component.exports